// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"57":"courseAdmin","379":"landingPage","800":"authFunctions","899":"simulation"}[chunkId] + "." + {"57":"629c2692","379":"fb6fd776","800":"1e5fd9df","899":"643243a3"}[chunkId] + ".css";
};